import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}age-group-product`;

export const getAgeGroupProduct = () => {
    const token = localStorage.getItem('token');

    return axios.get(API_URL, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    })
}

export const getAgeGroupProductById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}